import { useQuery } from '@apollo/client';
import Typography from '@mui/material/Typography';
import ReplyIcon from '@mui/icons-material/Comment';
import Link from 'next/link';
import React, { useState } from 'react';
import getSlug from 'speakingurl';
import { APP_VERSION } from '../../../config';
import { GET_POST_BY_ID } from '../../../helpers/graphql/singlePost';
import CustomSnackbar from '../../Dashboard/Notifications/CustomSnackbar';
import PublishBtn from '../../Editor/PublishBtn';
import CommentItem from './CommentItem';

// The body arrives in the link, so anyone can craft it: the preview shows it
// as plain text. Publishing sends the raw text to the backend, which renders
// and sanitizes it like every other comment.
const textAsHtml = text =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/\n/g, '<br />');

export default function BlogComment({ query, user }) {
  const { id, name } = query;
  // A repeated parameter arrives as an array.
  const body = typeof query.body === 'string' ? query.body : '';

  const { data } = useQuery(GET_POST_BY_ID, {
    variables: {
      id,
    },
    ssr: false,
  });

  const [publishThis, setPublishThis] = useState(undefined);
  const [isPublished, setIsPublished] = useState(undefined);

  const triggerPublish = () => {
    const parentAuthor = data.postById.author.username;
    const commenttime = getSlug(new Date().toJSON()).replace(/-/g, '');
    const permlink = getSlug(`re-${parentAuthor}-${commenttime}`);
    setPublishThis({
      title: '',
      body,
      parentPermlink: data.postById.permlink,
      parentAuthor,
      app: APP_VERSION,
      permlink,
      isComment: true,
      parentId: id,
      rootId: id,
      rootAuthor: data.postById.author.username,
      rootPermlink: data.postById.permlink,
      rootTitle: data.postById.title,
      depth: 1,
    });
  };

  if (isPublished)
    return (
      <>
        <div className="container highlightLinks">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8">
              <CustomSnackbar
                variant="success"
                message="Published successfully"
              />
            </div>
          </div>
        </div>
      </>
    );
  if (!data || !data.postById) return <></>;
  return (
    <>
      <div className="container highlightLinks">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8">
            <Typography gutterBottom variant="h5">
              Do you want to publish this comment?
            </Typography>
            <Typography gutterBottom variant="body1">
              Replying to:{' '}
              <Link
                href={`@${data.postById.author.username}/${data.postById.permlink}`}
              >
                {data.postById.title}
              </Link>{' '}
              by{' '}
              <Link href={`@${data.postById.author.username}`}>
                @{data.postById.author.username}
              </Link>
            </Typography>
            <CommentItem
              withBtmPadding
              comment={{
                createdAt: new Date(),
                author: {
                  displayName: user || name,
                  username: user,
                  roles: ['guest'],
                },
                body: textAsHtml(body),
              }}
            />
            <div className="pt-2">
              <PublishBtn
                mt
                publishThis={publishThis}
                pastPublish={() => setIsPublished(true)}
                triggerPublish={triggerPublish}
                label={
                  <span>
                    Publish Comment <ReplyIcon />
                  </span>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
